export default function () {
  const widgetName = 'subpageBackground';
  const widgetOpts = subpageBackgroundOpts;

  function addBackground(data) {
    const items = data.items;

    const mainItem = items.find((item) => !item.Title.includes('Campbell'));
    const mainImg = mainItem.ImageWithPath.toString();
    const subItem = items.find((item) => item.Title.includes('Campbell'));
    const subImg = subItem ? subItem.ImageWithPath.toString() : mainImg;
    const overlay = $('<div class="wrapper-overlay"></div>');
    const logoCampbell = $(`<div class="logo-campbell"></div>`);
    // select body when it has not class 'homepage'
    const body = $('body:not(.homepage)');
    if (body.hasClass('subtheme-campbell')) {
      $(body).find('.wrapper').prepend(overlay);
      $(body).find('.wrapper').prepend(logoCampbell);
      overlay.css('background-image', `url('${subImg}')`);
    } else {
      $(body).find('.wrapper').css('background-image', `url('${mainImg}')`);
    }
    $(`#${widgetName}`).remove();
  }

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW',
    },
    cardWidgetLoaded: function (data, owl, hasData) {
      addBackground(data);
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: [], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 1,
    moreButton: {
      visible: false,
      text: 'MORE',
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: false,
    textOverImage: false,
  });
}
